import { render, staticRenderFns } from "./WishGoodsCard.vue?vue&type=template&id=5bcb6400&scoped=true"
import script from "./WishGoodsCard.vue?vue&type=script&lang=js"
export * from "./WishGoodsCard.vue?vue&type=script&lang=js"
import style0 from "./WishGoodsCard.vue?vue&type=style&index=0&id=5bcb6400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb6400",
  null
  
)

export default component.exports